import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private messageService: MessageService) {}

    // Shared lookup APIs — 403 here is handled by the page; don't spam toast
    private static readonly SILENT_403_URL = /\/company\/branch-list|\/departments\/list-all|\/branch\/list-department\//i;

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                const isSilentLookup403 =
                    error.status === 403 &&
                    ErrorInterceptor.SILENT_403_URL.test(request.url || '');

                if (!isSilentLookup403) {
                    let errorMessage = '';
                    if (error.error instanceof ErrorEvent) {
                        errorMessage = error.error.message;
                    } else {
                        errorMessage = error.error && error.error.message ? error.error.message : error.message;
                    }
                    this.messageService.add({severity:'error', summary: 'Error', detail: errorMessage, life: 3000});
                }

                return throwError(() => error);
            })
        );
    }
}
